import { IndexApiSet, useIndexApi } from 'utils/network/api_hooks'
import { Form } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { User, UserSearchForm } from 'entities/user'

type UsersResponse = PagingResponse & {
    results: User[]
}

export function useFetchUsersApi(searchForm?: Form<UserSearchForm>): IndexApiSet<UsersResponse> & { execute: () => void } {
    const apiPath = 'users/'
    const api = useIndexApi<UsersResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: searchForm?.object?.page || 1, perPage: searchForm?.object?.perPage || 100000000 },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

type UserResponse = PagingResponse & {
    user: User
}

export function useFetchLoginUserApi(): IndexApiSet<UserResponse> & { execute: () => void } {
    const apiPath = 'users/login_user/'
    const api = useIndexApi<UserResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, user: {} },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}
